import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'ui-components/components/input';
import { emptyArray } from 'ui-components/default-props/empty';
import { useFocusOnComponent } from '../../hooks/use-focus-on-component';
import { ItemsDropdown } from './items-dropdown';
import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {Array} props.items
 * @param {string} props.value
 * @param {(value: string|React.ChangeEvent<HTMLInputElement>) => void} props.onChange
 * @param {MessageDescriptorPropType} props.placeholder
 * @returns {JSX.Element}
 */
export const InputWithAutocomplete = ({ items = emptyArray, value, onChange, placeholder, ...props }) => {
  const [currentItems, setCurrentItems] = useState(items);
  const { ref, isFocused, onFocus } = useFocusOnComponent();
  const intl = useIntl();

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  const onSelect = (e) => {
    onChange(e);
    setCurrentItems(emptyArray);
  };

  const filterItems = (itemsToFilter, inputValue) => {
    if (itemsToFilter?.length > 0) {
      const filteredItems = itemsToFilter.filter((i) => i.name.includes(inputValue.toLowerCase()));
      return filteredItems;
    }
    return emptyArray;
  };

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  const onValueChange = (e) => {
    onChange(e.target.value);
    const filteredItems = filterItems(items, e.target.value);
    setCurrentItems(filteredItems);
  };
  return (
    <div ref={ref} className={styles['search-results']} onFocus={onFocus}>
      <Input onChange={onValueChange} placeholder={intl.formatMessage(placeholder)} value={value} version='version2' {...props} />
      {isFocused && currentItems.length > 0 && <ItemsDropdown items={currentItems} onChange={onSelect} />}
    </div>
  );
};
